module.exports = __webpack_public_path__ + "BG.png?cf8a030a5c7098e3e9c35e2d5755516f";